import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import { useCallback, useMemo } from 'react';
import RichtextFormatter from './RichtextFormatter.jsx';

const RichTextField = ({
    name,
    label,
    value,
    onChange,
    helperText,
    error = false,
    required = false,
    disabled = false,
    placeholder,
    formControlProps = {},
}) => {

    const normalizedValue = useMemo(() => {
        if (value === null || value === undefined) {
            return value
        }

        if (Array.isArray(value)) {
            return value
        }

        if (typeof value === 'string') {
            try {
                return JSON.parse(value)
            } catch (error) {
                return [{ type: 'paragraph', children: [{ text: value }] }]
            }
        }

        return value;
    }, [value])

    const handleEditorChange = useCallback((editorValue) => {
        if (!onChange) {
            return;
        }

        const serializedValue = JSON.stringify(editorValue);
        const syntheticEvent = {
            target: {
                name,
                value: serializedValue,
            },
        };

        onChange(syntheticEvent);
    }, [name, onChange]);

    return (
        <FormControl
            fullWidth
            error={error}
            required={required}
            {...formControlProps}
        >
            {label && (
                <InputLabel
                    shrink
                    error={error}
                    required={required}
                    disabled={disabled}
                    sx={{
                        position: 'relative',
                        transform: 'none',
                        mb: 1
                    }}
                >
                    {label}
                </InputLabel>
            )}
            <RichtextFormatter
                style={{ marginBottom: '2rem' }}
                disabled={disabled}
                comment={normalizedValue}
                label={placeholder || label}
                setComment={handleEditorChange}
            />
            {(helperText !== undefined) && (
                <FormHelperText>
                    {helperText || ''}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default RichTextField;
